import { render, staticRenderFns } from "./waterSampleSeriesTable.vue?vue&type=template&id=14982f84&scoped=true"
import script from "./waterSampleSeriesTable.vue?vue&type=script&lang=js"
export * from "./waterSampleSeriesTable.vue?vue&type=script&lang=js"
import style0 from "./waterSampleSeriesTable.vue?vue&type=style&index=0&id=14982f84&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14982f84",
  null
  
)

export default component.exports